import { Injectable } from '@angular/core'
import { TranslationService } from '@evologi/shared/util-translation'
import { MessageService } from 'primeng/api'
import {
  NotificationOptions,
  NotificationColor,
  NgNotificationServiceInterface,
} from '@evologi/shared/data-access-api'

export type { NotificationColor }
export type { NotificationOptions }

@Injectable({ providedIn: 'root' })
export class NgNotificationService implements NgNotificationServiceInterface {
  constructor(
    private messageService: MessageService,
    private translationService: TranslationService,
  ) {}

  /**
   * Shows a toast notification
   * @param options - The notification options
   */
  show(options: NotificationOptions): void {
    this.messageService.add({
      severity: options.color ?? 'info',
      summary: options.title
        ? this.translationService.translate(options.title)
        : '',
      detail: options.message
        ? this.translationService.translate(options.message)
        : '',
      sticky: options.disableTimeout === true,
      life: options.disableTimeout ? undefined : 5000,
      closable: options.disableHide !== true,
      styleClass: options.bigger ? 'op-toast-lg' : undefined,
      data: { onClick: options.onClick },
    })
  }
}
